<template>
  <div class="pa-sm-5">
    <BaseButton
        color="primary"
        :btnText="$t('buttons:add-specific', { specific: $t('common:activity_plural') })"
        @clickedButton="$refs.eventLogDialogForm.openDialog(eventLog.options, eventLog.category)"
    />

    <FacilityEventLogDialogForm
        ref="eventLogDialogForm"
        @updateEventLogs="updateTimeLine"
    />

    <ScrollTimeLine
        class="mt-3"
        ref="scrollTimeLine"
        :showFacilityName="false"
        @updateData="updateTimeLine">
    </ScrollTimeLine>
  </div>
</template>

<script>
import EventLogService from '@/modules/book/services/eventlog-service';

import Utils from '@/modules/core/services/utils';

import ScrollTimeLine from '@/modules/book/components/ScrollTimeLine/ScrollTimeLine';
import FacilityEventLogDialogForm from '../formDialogs/FacilityEventLogDialogForm'
import BaseButton from '@/modules/core/components/Base/BaseButton';
import DocumentationService from '@/modules/core/services/documentation-service';
import Vue from 'vue';
import DateUtils from '@/modules/core/services/date-utils';

export default {
  name: 'FacilityActivityTab',
  components: {
    ScrollTimeLine,
    FacilityEventLogDialogForm,
    BaseButton
  },
  data() {
    return {
      eventLog: {
        options: null,
        category: null
      }
    }
  },
  methods: {
    updateTimeLine(options, category) {
      if (!category) category = '';

      this.eventLog.category = category;
      this.eventLog.options = options;

      EventLogService.readPageableEventLogsByFacility(
          this.$route.params.id,
          category,
          options.page - 1,
          options.itemsPerPage,
          "",
          options.sort,
          options.sortAsc,
          (res) => {
            res.data.content.forEach((log) => {
              if (log.documentations.length > 0) {
                log.isImageActivity = true;

                DocumentationService.readInfoListFromApi(log.documentations,
                    (res) => {
                      log.documentations = res.data;

                      for (let docu of log.documentations) {
                        DocumentationService.getDocByTypeAndId(
                            docu.id,
                            docu.fileType,
                            docu.documentType,
                            this.$route.params.id,
                            (docuFile) => {
                              docu.formattedSavedOn = DateUtils.parseDateTimeForDisplay(docu.savedOn);
                              Vue.set(docu, "src", docuFile)
                            }
                        )
                      }
                    },
                    (error) => {
                      this.$logger.error("Failed loading documentations log " + log.id + ", because: " + error);
                      Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:documentation_plural')}));
                    }
                )
              }
            })
            this.checkTaskStatus(res.data.content);
            this.$refs.scrollTimeLine.fillTimeLine(res.data);
          }
      )
    },
    checkTaskStatus(statuses) {
      if (statuses.length === 0) return;

      for (let i = 0; i < statuses.length; i++) {
        if (statuses[i] && statuses[i].eventLogType === 'TASK') {
          statuses[i].eventLogEvent = statuses[i].text3;
        }
      }
    }
  }
}
</script>